import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import { Link, useHistory, Redirect } from "react-router-dom";
import { isEmpty, size } from "lodash";
import { showToast } from '../../UI/ui-toast'
import { get_user_permissions } from "../../../helpers/custom_helper"

import DeleteModal from "../../../components/Common/DeleteModal";
import moment from "moment";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { get_all_customers, delete_customer } from '../api/customersApi';

import default_avatar from "../../../assets/images/avatar_01.png";
var customerEdit, customerView, customerCreate, customerDelete, customerLog;
class ListCustomers extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            page: 1,
            sizePerPage: 10,
            listData: [],
            listdata: "",
            viewmodal: false,
            modal: false,
            isOpen: false,
            selectDate: false,
            deleteModal: false,
            recordDeleteID: null,
            redirect: null
        };
        this.handleRecordClick = this.handleRecordClick.bind(this);
        this.handleViewCustomer = this.handleViewCustomer.bind(this);
        this.handleListDocuments = this.handleListDocuments.bind(this);
        this.handleAddNominee = this.handleAddNominee.bind(this);
        this.handleListNominee = this.handleListNominee.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleRecordClicks = this.handleRecordClicks.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.onClickActivityLog = this.onClickActivityLog.bind(this);
        this.handleListDeletedNominees = this.handleListDeletedNominees.bind(this);
    }
    componentDidMount() {
        customerEdit = get_user_permissions('customers-edit');
        customerView = get_user_permissions('customers-view');
        customerCreate = get_user_permissions('customers-create');
        customerDelete = get_user_permissions('customers-delete');
        customerLog = get_user_permissions('customer-logs-view');
        // window.localStorage.removeItem("current_customer_id")
        Promise.all([get_all_customers()]).then((values) => {
            console.log(values[0]);
            this.setState({ listData: values[0] });
        });

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listData } = this.props;
        if (!isEmpty(listData) && size(prevProps.listData) !== size(listData)) {
            this.setState({ listData: {}, isEdit: false });
        }
    }
    onPaginationPageChange = page => {
        if (
            this.node &&
            this.node.current &&
            this.node.current.props &&
            this.node.current.props.pagination &&
            this.node.current.props.pagination.options
        ) {
            this.node.current.props.pagination.options.onPageChange(page);
        }
    };
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ deleteModal: true });
    };

    handleDeletejob = () => {
        // const { onDeleteJobList } = this.props;
        const { listdata } = this.state;
        if (listdata.id !== undefined) {
            console.log(this.state.recordDeleteID);
            // onDeleteJobList(listdata);
            Promise.all([delete_customer(this.state.recordDeleteID)]).then((values) => {
                showToast("Success", "The customer " + listdata.full_name + " has been deleted successfully.", "success");
                Promise.all([get_all_customers()]).then((values) => {
                    console.log(values[0]);
                    this.setState({ listData: values[0] });
                });
            }).catch((error) => {
                showToast("Failed", "Customer Not Deleted Successfully", "error");
            });
            this.setState({ deleteModal: false });
        }
    };
    handleRecordClicks = () => {
        this.setState({ listdata: "", isEdit: false });
        this.toggle();
    };
    onClickActivityLog = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customer/log" });
    }
    handleRecordClick = arg => {
        const listdata = arg;

        //let history = useHistory();

        /*this.setState({
            listdata: {
                id: listdata.id,
                name: listdata.name,
            },
            isEdit: true,
        });*/

        //this.toggle();
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customers/edit" });
        //history.push("/customers/edit");
        //return  <Redirect  to="/customers/edit" />

    };

    handleListDocuments = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customers/documents" });
    };

    handleViewCustomer = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customers/view" });
    };

    handleAddNominee = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customer/nominee/add" });
    };

    handleListNominee = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customer/nominees/list" });
    };
    handleListDeletedNominees = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_customer_id", listdata.id);
        this.setState({ redirect: "/customer/deleted/nominees/list" });
    };
    render() {

        const { isEdit, deleteModal } = this.state;

        const listdata = this.state.listdata;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        const columns = [
            // {
            //     dataField: "id",
            //     text: "Id",
            //     sort: true,
            // },
            {
                dataField: "picture_path",
                text: "",
                sort: false,
                formatter: (cellContent, listdata) => (

                    <div>
                        <img src={listdata.picture_path == null ? default_avatar : listdata.picture_path} alt="Image not found!" className="avatar-sm" />
                    </div>

                ),
            },
            {
                dataField: "full_name",
                text: "Name",
                sort: true,
            },
            {
                dataField: "country",
                text: "Country",
                sort: true,
            },
            {
                dataField: "city",
                text: "City",
                sort: true,
            },
            {
                dataField: "updated_name",
                text: "Updated By",
                sort: true,
            },
            // {
            //     dataField: "created_at",
            //     text: "Created at",
            //     sort: true,
            //     formatter: (cellContent, listdata) => (
            //         <>
            //             {moment(listdata.created_at).format('DD/MM/YYYY h:mma')}
            //         </>

            //     ),

            // },
            {
                dataField: "updated_at",
                text: "Updated At",
                sort: true,
                formatter: (cellContent, listdata) => (
                    <>
                        {moment(listdata.updated_at).format('DD/MM/YYYY h:mma')}
                    </>

                ),
            },
            {
                dataField: "action",
                isDummyField: true,
                text: "Action",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {customerView ? <>
                                {customerLog ? <>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-primary"
                                            onClick={() => this.onClickActivityLog(listdata)}
                                        >
                                            <i className="mdi mdi-file-document-outline" id="logtooltip" />
                                            <UncontrolledTooltip placement="top" target="logtooltip">
                                                Activity Log
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </> : <></>}
                            </> : <></>}
                            {customerView ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.handleViewCustomer(listdata)}
                                    >
                                        <i className="mdi mdi-eye-outline" id="viewCustomer" />
                                        <UncontrolledTooltip placement="top" target="viewCustomer">
                                            View Customer
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => this.handleListDocuments(listdata)}
                                >
                                    <i className="mdi mdi-file-outline" id="ListDocuments" />
                                    <UncontrolledTooltip placement="top" target="ListDocuments">
                                        View Documents
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                            {customerEdit ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.handleRecordClick(listdata)}
                                    >
                                        <i className="mdi mdi-pencil-outline" id="edittooltip" />
                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                            Edit
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            {customerDelete ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() => this.onClickDelete(listdata)}
                                    >
                                        <i className="mdi mdi-delete-outline" id="deletetooltip" />
                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                            Delete
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                        </ul>
                    </>
                ),
            },
            {
                dataField: "Nominees",
                isDummyField: true,
                text: "Nominees",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {customerCreate ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.handleAddNominee(listdata)}
                                    >
                                        <i className="mdi mdi-account-plus-outline" id="addNominees" />
                                        <UncontrolledTooltip placement="top" target="addNominees">
                                            Add Nominee
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-success"
                                    onClick={() => this.handleListNominee(listdata)}
                                >
                                    <i className="mdi mdi-view-list-outline" id="listNominees" />
                                    <UncontrolledTooltip placement="top" target="listNominees">
                                        List Nominees
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                            {listdata.deleted_nominee_count > 0 ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() => this.handleListDeletedNominees(listdata)}
                                    >
                                        <i className="mdi mdi-view-list" id="deletedNomineestooltip" />
                                        <UncontrolledTooltip placement="top" target="deletedNomineestooltip">
                                            List Deleted Nominees
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                        </ul>
                    </>
                ),
            },

        ];

        const defaultSorted = [
            {
                dataField: "id",
                order: "asc",
            },
        ];

        const pageOptions = {
            sizePerPage: 10,
            // totalSize: productsData.length, // replace later with size(customers),
            custom: true,
        };

        // Select All Button operation
        const selectRow = {
            mode: "checkbox",
        };

        const { SearchBar } = Search;

        //meta title
        document.title = "List Customers";
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                console.log(row);
                this.setState({ recordDeleteID: row.id });

            }
        }
        return (
            <React.Fragment>
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeletejob}
                    record={`customer`}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="Customers" breadcrumbItem="List Customers" />

                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1">List Customers</h5>
                                                {customerCreate ? <>
                                                    <div className="flex-shrink-0">
                                                        <Link to="/customers/add" className="btn btn-primary me-1">Add New Customer</Link>
                                                    </div>
                                                </> : <></>}
                                            </div>
                                        </CardBody>
                                        <PaginationProvider
                                            pagination={paginationFactory(pageOptions)}
                                            keyField="id"
                                            columns={columns}
                                            data={this.state.listData}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="id"
                                                    columns={columns}
                                                    data={this.state.listData}
                                                    search
                                                >
                                                    {toolkitProps => (
                                                        <React.Fragment>
                                                            <Row className="mb-2">
                                                                <Col md="4">
                                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                                        <div className="position-relative">
                                                                            <SearchBar
                                                                                {...toolkitProps.searchProps}
                                                                            />
                                                                            <i className="bx bx-search-alt search-icon" />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <BootstrapTable
                                                                            keyField={"id"}
                                                                            responsive
                                                                            bordered={false}
                                                                            striped={false}
                                                                            defaultSorted={defaultSorted}
                                                                            selectRow={selectRow}
                                                                            rowEvents={rowEvents}
                                                                            classes={
                                                                                "table align-middle table-nowrap"
                                                                            }
                                                                            headerWrapperClasses={"thead-light"}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}
                                                                            ref={this.node}
                                                                        />
                                                                        <Modal
                                                                            isOpen={this.state.modal}
                                                                            className={this.props.className}
                                                                        >
                                                                            <ModalHeader toggle={this.toggle} tag="h4">
                                                                                {!!isEdit ? "Edit Customer" : "Add Customer"}
                                                                            </ModalHeader>
                                                                            <ModalBody>
                                                                                <Formik
                                                                                    enableReinitialize={true}
                                                                                    initialValues={{
                                                                                        id: (listdata && listdata.id) || '',
                                                                                        name: (listdata && listdata.name) || '',
                                                                                    }}
                                                                                    validationSchema={Yup.object().shape({
                                                                                        id: Yup.string().required("Please Enter Your Id"),
                                                                                        name: Yup.string().required("Please Enter Your Name"),
                                                                                    })}
                                                                                    onSubmit={values => {
                                                                                        /*Promise.all([update_project(values.id, values.name)]).then((response) => {
                                                                                            console.log(response[0]);
                                                                                            Promise.all([get_all_customers()]).then((values) => {
                                                                                                console.log(values[0]);
                                                                                                this.setState({ listData: values[0] });
                                                                                            });
                                                                                        });*/
                                                                                        this.toggle();
                                                                                    }}
                                                                                >
                                                                                    {({ errors, status, touched }) => (
                                                                                        <Form>
                                                                                            <Row>
                                                                                                <Col className="col-12">
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Property Type Id
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="id"
                                                                                                            disabled
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.id &&
                                                                                                                    touched.id
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="id"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Name
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="name"
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.name &&
                                                                                                                    touched.name
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="name"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <div className="text-end">
                                                                                                        <button
                                                                                                            type="submit"
                                                                                                            className="btn btn-primary save-user"
                                                                                                        >
                                                                                                            Save
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Form>
                                                                                    )}
                                                                                </Formik>
                                                                            </ModalBody>
                                                                        </Modal>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="align-items-md-center mt-30">
                                                                <Col className="inner-custom-pagination d-flex">
                                                                    <div className="d-inline">Results Per Page&nbsp;&nbsp;
                                                                        <SizePerPageDropdownStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                    <div className="text-md-right ms-auto">
                                                                        <PaginationListStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default ListCustomers;
